import React from 'react';
import RadioButton from '@wix/da-ds/pkg/RadioButton';
import premiumFormStyles from './PremiumForm.scss';
export var FolderTypeRadioButton = function (_a) {
    var value = _a.value, isSelected = _a.isSelected, onChange = _a.onChange, title = _a.title, hint = _a.hint, children = _a.children;
    return (React.createElement(RadioButton, { name: "folderType", value: value, checked: isSelected(value), onChange: function () { return onChange(value); }, className: premiumFormStyles['folder-type-radio'], size: "small", withMargins: true },
        React.createElement("div", { className: premiumFormStyles['label-block'] },
            React.createElement("div", { className: premiumFormStyles['label-header'] }, title),
            React.createElement("div", { className: premiumFormStyles['label-hint'] }, hint),
            children)));
};
FolderTypeRadioButton.displayName = 'FolderTypeRadioButton';
export default FolderTypeRadioButton;
//# sourceMappingURL=FolderTypeRadioButton.js.map